export default "__VITE_ASSET__68cc58f3__"